(function () {
  function getBrand() {
    return document.documentElement.getAttribute('data-brand') === 'mlo' ? 'mlo' : 'malloni';
  }

  function setBrand(brand) {
    var value = brand === 'mlo' ? 'mlo' : 'malloni';
    document.documentElement.setAttribute('data-brand', value);
    syncSwitcherState();
    closeAllBrandMenus();
  }

  function syncSwitcherState() {
    var brand = getBrand();
    document.querySelectorAll('[data-os-brand-set]').forEach(function (button) {
      var isActive = button.getAttribute('data-os-brand-set') === brand;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function getSubmenuForToggle(toggle) {
    var item = toggle.closest('.os-brand-menu__item');
    if (item) {
      var inlineSubmenu = item.querySelector(':scope > .os-brand-menu__submenu');
      if (inlineSubmenu) {
        return inlineSubmenu;
      }
    }

    var menuRoot = toggle.closest('.os-brand-menu');
    var controlsId = toggle.getAttribute('aria-controls');

    if (controlsId && menuRoot) {
      return menuRoot.querySelector('[id="' + controlsId + '"]');
    }

    return item ? item.querySelector('.os-brand-menu__submenu') : null;
  }

  function syncHeaderSubmenuState() {
    var hasOpen = document.querySelector('.os-brand-menu--desktop .os-brand-menu__submenu--panel:not([hidden])');
    var headerWrapper = document.querySelector('.header-wrapper');
    var stickyHeader = document.querySelector('sticky-header');
    var sectionHeader = document.querySelector('.section-header');

    if (headerWrapper) {
      headerWrapper.classList.toggle('os-brand-header--submenu-open', !!hasOpen);
    }

    document.documentElement.classList.toggle('os-brand-header--submenu-open', !!hasOpen);

    if (stickyHeader && typeof stickyHeader.setHeaderHeight === 'function') {
      stickyHeader.setHeaderHeight();
    } else if (sectionHeader) {
      document.documentElement.style.setProperty('--header-height', sectionHeader.offsetHeight + 'px');
    }
  }

  function positionDesktopSubmenu(toggle, submenu) {
    var desktopMenu = toggle.closest('.os-brand-menu--desktop');
    var itemRow = toggle.closest('.os-brand-menu__item-row');
    var submenuInner = submenu.querySelector('.os-brand-menu__submenu-inner');
    var submenuList = submenu.querySelector('.os-brand-menu__submenu-list');

    if (!desktopMenu || !itemRow || !submenuInner || !submenuList) {
      return;
    }

    submenuList.style.setProperty('--os-brand-submenu-offset', '0px');

    var itemRect = itemRow.getBoundingClientRect();
    var listRect = submenuList.getBoundingClientRect();
    var innerRect = submenuInner.getBoundingClientRect();
    var desiredOffset = itemRect.left - listRect.left;
    var maximumOffset = Math.max(0, innerRect.right - listRect.left - submenuList.scrollWidth);
    var offset = Math.max(0, Math.min(desiredOffset, maximumOffset));

    submenuList.style.setProperty('--os-brand-submenu-offset', offset + 'px');
  }

  function closeAllBrandMenus() {
    document.querySelectorAll('.os-brand-menu__toggle[aria-expanded="true"]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      var submenu = getSubmenuForToggle(toggle);
      if (submenu) {
        submenu.hidden = true;
      }
      var item = toggle.closest('.os-brand-menu__item');
      if (item) {
        item.classList.remove('is-open');
      }
    });
    syncHeaderSubmenuState();
  }

  function initSwitcher() {
    document.querySelectorAll('[data-os-brand-set]').forEach(function (link) {
      link.addEventListener('click', function () {
        var brand = link.getAttribute('data-os-brand-set');
        setBrand(brand);
      });
    });
    syncSwitcherState();
  }

  function toggleBrandSubmenu(toggle, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    var item = toggle.closest('.os-brand-menu__item');
    var submenu = getSubmenuForToggle(toggle);
    if (!item || !submenu) {
      return;
    }

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    var willOpen = !isOpen;

    item.closest('.os-brand-menu')?.querySelectorAll('.os-brand-menu__toggle[aria-expanded="true"]').forEach(function (openToggle) {
      if (openToggle === toggle) {
        return;
      }
      openToggle.setAttribute('aria-expanded', 'false');
      var openSubmenu = getSubmenuForToggle(openToggle);
      if (openSubmenu) {
        openSubmenu.hidden = true;
      }
      var openItem = openToggle.closest('.os-brand-menu__item');
      if (openItem) {
        openItem.classList.remove('is-open');
      }
    });

    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    submenu.hidden = !willOpen;
    item.classList.toggle('is-open', willOpen);
    if (willOpen) {
      positionDesktopSubmenu(toggle, submenu);
    }
    syncHeaderSubmenuState();
  }

  function initAccordion(root) {
    root.querySelectorAll('.os-brand-menu__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        toggleBrandSubmenu(toggle, event);
      });
    });
  }

  function syncMobileMenuLightState() {
    var isOpen = document.querySelector('.section-header.menu-open') !== null;
    document.documentElement.classList.toggle('os-header-menu-open', isOpen);
  }

  function initMobileDrawerLightSync() {
    var sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) {
      return;
    }

    syncMobileMenuLightState();

    var observer = new MutationObserver(function () {
      syncMobileMenuLightState();
    });
    observer.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
  }

  function initDrawers() {
    /* Intercetto in capture così MenuDrawer non tratta il "+" come pulsante di chiusura */
    document.addEventListener('click', function (event) {
      var drawerMenu = event.target.closest('.os-brand-menu--drawer');
      if (!drawerMenu) {
        return;
      }

      var toggle = event.target.closest('.os-brand-menu__toggle');
      if (!toggle) {
        var parentLink = event.target.closest('.os-brand-menu__link--parent');
        if (parentLink) {
          var itemRow = parentLink.closest('.os-brand-menu__item-row');
          toggle = itemRow ? itemRow.querySelector('.os-brand-menu__toggle') : null;
        }
      }

      if (!toggle) {
        return;
      }

      toggleBrandSubmenu(toggle, event);
    }, true);
  }

  function initDesktopMenus() {
    document.querySelectorAll('.os-brand-menu--desktop').forEach(function (menu) {
      initAccordion(menu);
    });
  }

  function init() {
    try {
      localStorage.removeItem('os_malloni_brand');
    } catch (error) {
      /* ignoro errori storage */
    }
    initSwitcher();
    initDesktopMenus();
    initDrawers();
    initMobileDrawerLightSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.OSBrandContext = {
    getBrand: getBrand,
    setBrand: setBrand,
  };
})();
